/* @flow */
import React from 'react';
import ReactDOM from 'react-dom';
import Menu from './components/Commons/Menu.jsx';
import Footer from './components/Commons/Footer.jsx';
import ContainerContacto from './components/Contacto/ContainerContacto.jsx';
import ContextUsers from './components/Login/ContextUser/Actions'

ReactDOM.render(
  <ContextUsers>
    <Menu iconoSiempre={true} turista={window.g.turista} noFix={true}/>
  </ContextUsers>,
  document.getElementById('reactMenu')
);
ReactDOM.render(
  <Footer socialIcons={false} />,
  document.getElementById('reactFooter')
);
ReactDOM.render(
	<ContainerContacto to={window.g.to}/>,
	document.getElementById('react')
);